export const integerReplace = (value: string) => value.replace(/\D+/g, "");
